import { CurrentUserProps, UserStoreProps } from "models/user";
import { create } from "zustand";

export const useUserStore = create<UserStoreProps>((set) => ({
	user: undefined,
	updateUser: (user: CurrentUserProps) => set((state) => ({user: { ...state.user, ...user } })),
}));
